import type { IconSvgObject } from './types';

const MilkBottleIcon: IconSvgObject = [
  ["path", { d: "M15.2459 4.92311C15.8954 4.7243 16.3636 4.16227 16.3636 3.5C16.3636 2.67157 15.631 2 14.7273 2H9.27273C8.36899 2 7.63636 2.67157 7.63636 3.5C7.63636 4.15311 8.09171 4.70873 8.72727 4.91465C8.89788 4.96992 10 5 10 5M8.72727 4.91465C7.10674 7.88562 6 10.3773 6 13.7771V20C6 21.1046 6.89543 22 8 22H16C17.1046 22 18 21.1046 18 20V13.7771C18 10.3773 16.8664 7.89408 15.2459 4.92311M15.2459 4.92311C15.0829 4.97298 14 5 14 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 12L18 15", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MilkBottleIcon;
